export function parseFilenameFromDisposition(contentDisposition) {
  if (!contentDisposition) {
    return 'download.csv';
  }

  const match = contentDisposition.match(/filename="?([^"]+)"?/);

  return match ? match[1] : 'download.csv';
}

export function isCsvContentType(contentType = '') {
  return /text\/csv|application\/(csv|octet-stream|vnd\.ms-excel)/i.test(
    contentType
  );
}

export async function parseBlobAsJson(blob) {
  try {
    const text = await blob.text();
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export async function getExportErrorMessage(
  error,
  fallback = 'Não foi possível exportar o relatório.'
) {
  const data = error?.response?.data;

  if (data instanceof Blob) {
    const parsed = await parseBlobAsJson(data);
    return parsed?.errors?.[0]?.message || fallback;
  }

  return data?.errors?.[0]?.message || error?.message || fallback;
}

export function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
